import {
    AddPhoneNumberFn,
    initAddPhoneNumberFn,
} from './lib/methods/add-phone-number';
import {
    initUpdatePhoneNumberFn,
    UpdatePhoneNumberFn,
} from './lib/methods/update-phone-number';
import {
    acceptCustomerAgreementAndPrivacyPolicyFn,
    AcceptCustomerAgreementAndPrivacyPolicyFn,
} from './lib/methods/accept-customer-agreement-and-privacy-policy';
import {
    acceptMarketingOffersFn,
    AcceptMarketingOffersFn,
} from './lib/methods/accept-marketing-offers';
import {
    acceptOfferAndRenewalTermsFn,
    AcceptOfferAndRenewalTermsFn,
} from './lib/methods/accept-offer-and-renewal-terms';
import { GetIdentityFn, initGetIdentityFn } from './lib/methods/get-identity';
import { GetAccountFn, initGetAccountFn } from './lib/methods/get-account';
import {
    GetDefaultBillingProfileFn,
    initGetDefaultBillingProfileFn,
} from './lib/methods/get-default-billing-profile';
import {
    GetDefaultPaymentMethodFn,
    initGetDefaultPaymentMethodFn,
} from './lib/methods/get-default-payment-method';
import { GetNextBillFn, initGetNextBillFn } from './lib/methods/get-next-bill';
import {
    GetPaymentHistoryFn,
    initGetPaymentHistoryFn,
} from './lib/methods/get-payment-history';
import { GetInvoicesFn, initGetInvoicesFn } from './lib/methods/get-invoices';
import {
    initRegisterGiftCardFn,
    RegisterGiftCardFn,
} from './lib/methods/register-gift-card';
import {
    initRegisterAndRedeemGiftCardFn,
    RegisterAndRedeemGiftCardFn,
} from './lib/methods/register-and-redeem-gift-card';
import {
    GetNewHotAndTrendingFn,
    initGetNewHotAndTrendingFn,
} from './lib/methods/get-new-hot-and-trending';
import { GetInvoiceFn, initGetInvoiceFn } from './lib/methods/get-invoice';
import { DeleteFn, initDeleteFn } from './lib/methods/delete';
import {
    initUpdateEmailAddressFn,
    UpdateEmailAddressFn,
} from './lib/methods/update-email-address';
import {
    initUpdatePasswordFn,
    UpdatePasswordFn,
} from './lib/methods/update-password';
import {
    initUpdateFirstAndLastNameFn,
    UpdateFirstAndLastNameFn,
} from './lib/methods/update-first-and-last-name';
import {
    initUpdateServiceAddressFn,
    UpdateServiceAddressFn,
} from './lib/methods/update-service-address';
import {
    initUpdateBillingAddressFn,
    UpdateBillingAddressFn,
} from './lib/methods/update-billing-address';
import {
    initGetDefaultRegionCodeFn,
    GetDefaultRegionCodeFn,
} from './lib/methods/get-default-region-code';
import {
    AddPaymentMethodStripeFn,
    initAddPaymentMethodStripeFn,
} from './lib/methods/add-payment-method-stripe';
import { AddPasswordFn, initAddPasswordFn } from './lib/methods/add-password';
import {
    GetDefaultPaymentMethodCreditCardFn,
    initGetDefaultPaymentMethodCreditCardFn,
} from './lib/methods/get-default-payment-method-credit-card';
import { GetFullNameFn, initGetFullNameFn } from './lib/methods/get-full-name';
import {
    AddPaymentMethodStripeWithNamePhoneZipFn,
    initAddPaymentMethodStripeWithNamePhoneZipFn,
} from './lib/methods/add-payment-method-stripe-with-name-phone-zip';
import {
    AddPaymentMethodStripeWithNamePhoneAddressFn,
    initAddPaymentMethodStripeWithNamePhoneAddressFn,
} from './lib/methods/add-payment-method-stripe-with-name-phone-address';
import {
    initPayInvoiceStripeFn,
    PayInvoiceStripeFn,
} from './lib/methods/pay-invoice-stripe';
import {
    initLogCreateStripePaymentMethodErrorFn,
    LogCreateStripePaymentMethodErrorFn,
} from './lib/methods/log-create-stripe-payment-method-error';
import {
    initUpdateFirstLastNameZipAndCountryFn,
    UpdateFirstLastNameZipAndCountryFn,
} from './lib/methods/update-first-last-name-zip-and-country';
import {
    initUpdateFirstLastNameStateZipAndCountryFn,
    UpdateFirstLastNameStateZipAndCountryFn,
} from './lib/methods/update-first-last-name-state-zip-and-country';
import {
    initUpdateServiceAddressWhenExistingZipMatchesFn,
    UpdateServiceAddressWhenExistingZipMatchesFn,
} from './lib/methods/update-service-address-when-existing-zip-matches';
import { HandleFn, initHandleFn } from './lib/methods/handle';
import { AccountDomainInitPayload } from './lib/types/domain';
import {
    HasPhoneNumberFn,
    initHasPhoneNumberFn,
} from './lib/methods/has-phone-number';
import {
    initPrivacyOptionsOptOutFn,
    PrivacyOptionsOptOutFn,
} from './lib/methods/privacy-options-opt-out';
import {
    initVerifyAccountLpzFn,
    VerifyAccountLpzFn,
} from './lib/methods/verify-account-lpz';
import {
    GetSmsAccountDataFn,
    initGetSmsAccountDataFn,
} from './lib/methods/get-sms-account-data';
import {
    initSendRefreshSignalFn,
    SendRefreshSignalFn,
} from './lib/methods/send-refresh-signal';
import {
    initSendRefreshInstructionsFn,
    SendRefreshInstructionsFn,
} from './lib/methods/send-refresh-instructions';

export interface DomainAccount {
    acceptCustomerAgreementAndPrivacyPolicy: AcceptCustomerAgreementAndPrivacyPolicyFn;
    acceptMarketingOffers: AcceptMarketingOffersFn;
    acceptOfferAndRenewalTerms: AcceptOfferAndRenewalTermsFn;
    addPhoneNumber: AddPhoneNumberFn;
    addPassword: AddPasswordFn;
    updatePhoneNumber: UpdatePhoneNumberFn;
    updateEmailAddress: UpdateEmailAddressFn;
    updatePassword: UpdatePasswordFn;
    updateFirstAndLastName: UpdateFirstAndLastNameFn;
    updateFirstLastNameStateZipAndCountry: UpdateFirstLastNameStateZipAndCountryFn;
    updateFirstLastNameZipAndCountry: UpdateFirstLastNameZipAndCountryFn;
    updateServiceAddress: UpdateServiceAddressFn;
    updateServiceAddressWhenExistingZipMatches: UpdateServiceAddressWhenExistingZipMatchesFn;
    updateBillingAddress: UpdateBillingAddressFn;
    addPaymentMethodStripe: AddPaymentMethodStripeFn;
    addPaymentMethodStripeWithNamePhoneZip: AddPaymentMethodStripeWithNamePhoneZipFn;
    addPaymentMethodStripeWithNamePhoneAddress: AddPaymentMethodStripeWithNamePhoneAddressFn;
    getIdentity: GetIdentityFn;
    getAccount: GetAccountFn;
    getSmsAccount: GetSmsAccountDataFn;
    handle: HandleFn;
    hasPhoneNumber: HasPhoneNumberFn;
    getDefaultRegionCode: GetDefaultRegionCodeFn;
    getDefaultBillingProfile: GetDefaultBillingProfileFn;
    getDefaultPaymentMethod: GetDefaultPaymentMethodFn;
    getNextBill: GetNextBillFn;
    getPaymentHistory: GetPaymentHistoryFn;
    getInvoices: GetInvoicesFn;
    getInvoice: GetInvoiceFn;
    registerGiftCard: RegisterGiftCardFn;
    registerAndRedeemGiftCard: RegisterAndRedeemGiftCardFn;
    getNewHotAndTrending: GetNewHotAndTrendingFn;
    delete: DeleteFn;
    payInvoiceStripe: PayInvoiceStripeFn;
    getDefaultPaymentMethodCreditCard: GetDefaultPaymentMethodCreditCardFn;
    getFullName: GetFullNameFn;
    logCreateStripePaymentMethodError: LogCreateStripePaymentMethodErrorFn;
    privacyOptionsOptOut: PrivacyOptionsOptOutFn;
    verifyAccountLpz: VerifyAccountLpzFn;
    sendRefreshSignal: SendRefreshSignalFn;
    sendRefreshInstructions: SendRefreshInstructionsFn;
}

export function domainAccount(
    domainInitPayload: AccountDomainInitPayload,
): DomainAccount {
    return {
        acceptCustomerAgreementAndPrivacyPolicy:
            acceptCustomerAgreementAndPrivacyPolicyFn(domainInitPayload),
        acceptMarketingOffers: acceptMarketingOffersFn(domainInitPayload),
        acceptOfferAndRenewalTerms:
            acceptOfferAndRenewalTermsFn(domainInitPayload),
        addPhoneNumber: initAddPhoneNumberFn(domainInitPayload),
        addPassword: initAddPasswordFn(domainInitPayload),
        updatePhoneNumber: initUpdatePhoneNumberFn(domainInitPayload),
        updateEmailAddress: initUpdateEmailAddressFn(domainInitPayload),
        updatePassword: initUpdatePasswordFn(domainInitPayload),
        updateFirstAndLastName: initUpdateFirstAndLastNameFn(domainInitPayload),
        updateFirstLastNameStateZipAndCountry:
            initUpdateFirstLastNameStateZipAndCountryFn(domainInitPayload),
        updateFirstLastNameZipAndCountry:
            initUpdateFirstLastNameZipAndCountryFn(domainInitPayload),
        updateServiceAddress: initUpdateServiceAddressFn(domainInitPayload),
        updateServiceAddressWhenExistingZipMatches:
            initUpdateServiceAddressWhenExistingZipMatchesFn(domainInitPayload),
        updateBillingAddress: initUpdateBillingAddressFn(domainInitPayload),
        addPaymentMethodStripe: initAddPaymentMethodStripeFn(domainInitPayload),
        addPaymentMethodStripeWithNamePhoneZip:
            initAddPaymentMethodStripeWithNamePhoneZipFn(domainInitPayload),
        addPaymentMethodStripeWithNamePhoneAddress:
            initAddPaymentMethodStripeWithNamePhoneAddressFn(domainInitPayload),
        getIdentity: initGetIdentityFn(domainInitPayload),
        getAccount: initGetAccountFn(domainInitPayload),
        getSmsAccount: initGetSmsAccountDataFn(domainInitPayload),
        handle: initHandleFn(),
        hasPhoneNumber: initHasPhoneNumberFn(domainInitPayload),
        getDefaultRegionCode: initGetDefaultRegionCodeFn(domainInitPayload),
        getDefaultBillingProfile:
            initGetDefaultBillingProfileFn(domainInitPayload),
        getDefaultPaymentMethod:
            initGetDefaultPaymentMethodFn(domainInitPayload),
        getNextBill: initGetNextBillFn(domainInitPayload),
        getPaymentHistory: initGetPaymentHistoryFn(domainInitPayload),
        getInvoices: initGetInvoicesFn(domainInitPayload),
        getInvoice: initGetInvoiceFn(domainInitPayload),
        registerGiftCard: initRegisterGiftCardFn(domainInitPayload),
        registerAndRedeemGiftCard:
            initRegisterAndRedeemGiftCardFn(domainInitPayload),
        getNewHotAndTrending: initGetNewHotAndTrendingFn(domainInitPayload),
        delete: initDeleteFn(domainInitPayload),
        payInvoiceStripe: initPayInvoiceStripeFn(domainInitPayload),
        getDefaultPaymentMethodCreditCard:
            initGetDefaultPaymentMethodCreditCardFn(domainInitPayload),
        getFullName: initGetFullNameFn(domainInitPayload),
        logCreateStripePaymentMethodError:
            initLogCreateStripePaymentMethodErrorFn(domainInitPayload),
        privacyOptionsOptOut: initPrivacyOptionsOptOutFn(domainInitPayload),
        verifyAccountLpz: initVerifyAccountLpzFn(domainInitPayload),
        sendRefreshSignal: initSendRefreshSignalFn(domainInitPayload),
        sendRefreshInstructions:
            initSendRefreshInstructionsFn(domainInitPayload),
    };
}
